/**
 * cart-sidebar.js v4
 * Panel lateral con popup de variantes al agregar
 */
(function () {
  'use strict';

  var CartSidebar = {
    collectionHandle: '',
    maxProducts: 6,
    title: 'También te puede gustar',
    _productsData: [],
    _productsHtml: null,

    init: function () {
      var config = document.getElementById('cart-sidebar-config');
      if (!config) return;
      this.collectionHandle = config.dataset.collection || '';
      this.maxProducts = parseInt(config.dataset.maxProducts || '6', 10);
      this.title = config.dataset.title || 'También te puede gustar';
      if (!this.collectionHandle) return;
      this._preloadProducts();
      this._bindEvents();
      this._buildPopup();
    },

    // ── Popup de variantes ────────────────────────────────────────────────────

    _buildPopup: function () {
      if (document.getElementById('crb-variant-popup')) return;
      var overlay = document.createElement('div');
      overlay.id = 'crb-variant-popup';
      overlay.className = 'crb-popup';
      overlay.innerHTML =
        '<div class="crb-popup__box">' +
          '<button class="crb-popup__close" id="crb-popup-close">✕</button>' +
          '<div class="crb-popup__product" id="crb-popup-product"></div>' +
          '<div class="crb-popup__variants" id="crb-popup-variants"></div>' +
          '<button class="crb-popup__add-btn" id="crb-popup-add-btn" disabled>Selecciona una opción</button>' +
        '</div>';
      document.body.appendChild(overlay);

      // Cerrar al hacer clic en overlay o X
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) CartSidebar._closePopup();
      });
      document.getElementById('crb-popup-close').addEventListener('click', function () {
        CartSidebar._closePopup();
      });
      document.getElementById('crb-popup-add-btn').addEventListener('click', function () {
        CartSidebar._confirmAdd();
      });
    },

    _openPopup: function (productHandle) {
      var product = this._productsData.find(function (p) { return p.handle === productHandle; });
      if (!product) return;

      this._currentProduct = product;
      this._selectedVariant = null;

      var popup = document.getElementById('crb-variant-popup');
      var productEl = document.getElementById('crb-popup-product');
      var variantsEl = document.getElementById('crb-popup-variants');
      var addBtn = document.getElementById('crb-popup-add-btn');

      // Info del producto
      var img = product.images && product.images[0]
        ? product.images[0].src.replace(/(\.[^.]+)$/, '_400x$1') : '';
      var v0 = product.variants[0];
      var price = CartSidebar._fmt(v0.price * 100);

      productEl.innerHTML =
        (img ? '<img class="crb-popup__img" src="' + img + '" alt="' + product.title + '">' : '') +
        '<div class="crb-popup__product-info">' +
          '<p class="crb-popup__product-name">' + product.title + '</p>' +
          '<p class="crb-popup__product-price">' + price + '</p>' +
        '</div>';

      // Detectar si tiene múltiples opciones (ej: talla + color) o solo una
      var options = product.options || [];
      var variantsHtml = '';

      if (options.length === 1 && options[0].name.toLowerCase() === 'title') {
        // Producto sin variantes reales → agregar directo
        this._selectedVariant = product.variants[0];
        variantsHtml = '';
        addBtn.textContent = 'Comprar';
        addBtn.disabled = false;
      } else {
        // Construir selector por cada opción
        options.forEach(function (opt, optIdx) {
          var values = [];
          product.variants.forEach(function (v) {
            var val = v['option' + (optIdx + 1)];
            if (val && values.indexOf(val) === -1) values.push(val);
          });

          var isColor = CartSidebar._isColorOption(opt.name);

          variantsHtml +=
            '<div class="crb-popup__option">' +
              '<p class="crb-popup__option-label">' + opt.name + '</p>' +
              '<div class="crb-popup__option-values' + (isColor ? ' crb-popup__option-values--swatches' : '') + '">';

          values.forEach(function (val) {
            var hasStock = product.variants.some(function (v) {
              return v['option' + (optIdx + 1)] === val && v.available;
            });

            if (isColor) {
              var swatchStyle = CartSidebar._getSwatchStyle(val);
              var isLight = swatchStyle && (swatchStyle.indexOf('#fff') !== -1 || swatchStyle.indexOf('#FFFF') !== -1 || swatchStyle.indexOf('#fef') !== -1 || swatchStyle.indexOf('#f5f') !== -1 || swatchStyle.indexOf('#e8') !== -1);
              variantsHtml +=
                '<button class="crb-popup__swatch' +
                  (hasStock ? '' : ' is-unavailable') +
                  (isLight ? ' is-light' : '') +
                  '" ' +
                  'data-option-idx="' + optIdx + '" data-value="' + val + '" ' +
                  'title="' + val + '" ' +
                  (swatchStyle ? 'style="' + swatchStyle + '"' : '') +
                  (hasStock ? '' : ' disabled') + '>' +
                  (!swatchStyle ? val : '') +
                '</button>';
            } else {
              variantsHtml +=
                '<button class="crb-popup__option-btn' + (hasStock ? '' : ' is-unavailable') + '" ' +
                  'data-option-idx="' + optIdx + '" data-value="' + val + '"' +
                  (hasStock ? '' : ' disabled') + '>' +
                  val +
                '</button>';
            }
          });

          variantsHtml += '</div></div>';
        });

        addBtn.textContent = 'Selecciona una opción';
        addBtn.disabled = true;
      }

      variantsEl.innerHTML = variantsHtml;

      // Bind botones de opción (tanto swatches como botones de texto)
      variantsEl.querySelectorAll('.crb-popup__option-btn, .crb-popup__swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var optIdx = btn.dataset.optionIdx;
          variantsEl.querySelectorAll('[data-option-idx="' + optIdx + '"]')
            .forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          CartSidebar._tryMatchVariant();
        });
      });

      popup.classList.add('is-open');
    },

    _tryMatchVariant: function () {
      var product = this._currentProduct;
      var variantsEl = document.getElementById('crb-popup-variants');
      var addBtn = document.getElementById('crb-popup-add-btn');
      var options = product.options || [];
      var selected = [];

      for (var i = 0; i < options.length; i++) {
        var btn = variantsEl.querySelector('.crb-popup__option-btn[data-option-idx="' + i + '"].is-selected, .crb-popup__swatch[data-option-idx="' + i + '"].is-selected');
        if (!btn) { selected = null; break; }
        selected.push(btn.dataset.value);
      }

      if (!selected) {
        this._selectedVariant = null;
        addBtn.textContent = 'Selecciona una opción';
        addBtn.disabled = true;
        return;
      }

      // Buscar la variante que coincida
      var match = product.variants.find(function (v) {
        return selected.every(function (val, idx) {
          return v['option' + (idx + 1)] === val;
        });
      });

      if (match && match.available) {
        this._selectedVariant = match;
        addBtn.textContent = 'Comprar';
        addBtn.disabled = false;
      } else {
        this._selectedVariant = null;
        addBtn.textContent = 'Sin stock';
        addBtn.disabled = true;
      }
    },

    _confirmAdd: function () {
      if (!this._selectedVariant) return;
      var addBtn = document.getElementById('crb-popup-add-btn');
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: this._selectedVariant.id, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          addBtn.classList.remove('is-loading');
          if (d.status && d.status >= 400) {
            addBtn.textContent = 'Sin stock';
            return;
          }
          CartSidebar._closePopup();
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.classList.remove('is-loading');
        });
    },

    _closePopup: function () {
      var popup = document.getElementById('crb-variant-popup');
      if (popup) popup.classList.remove('is-open');
      this._selectedVariant = null;
      this._currentProduct = null;
    },

    // ── Paleta de colores del tema ────────────────────────────────────────────
    _colorPalette: {
      'negro': '#000000',
      'beige': '#e8c39e',
      'moca': '#c28787',
      'mocca': '#B39B84',
      'rosa': '#ffc0cb',
      'rosado': '#ffc0cb',
      'palo rosa': '#e3aaaa',
      'gris': '#d3d3d3',
      'lila': '#b695c0',
      'verde': '#88e788',
      'verde agua': '#cceae8',
      'verde claro': '#b0d7c3',
      'verde perico': '#008000',
      'verde militar': '#273b09',
      'azul': '#003166',
      'azul oscuro': '#2d2c55',
      'azulino': '#003b85',
      'azul acero': '#1e2e4f',
      'celeste': '#bceeff',
      'crema': '#fef5da',
      'arena': '#e9ded0',
      'blanco': '#FFFFFF',
      'nude': '#ebc8b2',
      'ocre': '#cc7722',
      'amarillo': '#ffffbf',
      'coral': '#eb636b',
      'perla': '#f5f7e3',
      'fucsia': '#c6186c',
      'mostaza': '#e7ba54',
      'guinda': '#74091b',
      'vino': '#640d14',
      'melon': '#fa8072',
      'acero': '#859dbb',
      'cenizo': '#e2e2e2',
      'rojo': '#cf010b',
      'camel': '#c08552',
      'blanco-vino': '#9d0707',
      'blanco-negro': '#000000',
      'blanco-marron': '#804000',
      'blanco-copa': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-17_at_7.48.46_PM.jpg?v=1766423001',
      'blanco-cereza': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-17_at_7.49.46_PM.jpg?v=1766422984',
      'blanco-perfectly': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-17_at_7.47.01_PM.jpg?v=1766423010',
      'palo rosa-cereza': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-17_at_7.49.20_PM.jpg?v=1766422994',
      'palo rosa-love': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-17_at_7.50.15_PM.jpg?v=1766422970',
      'negro-believed': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-17_at_7.48.14_PM.jpg?v=1766423010',
      'camel-blessed': 'https://cdn.shopify.com/s/files/1/0841/2489/3461/files/WhatsApp_Image_2025-12-22_at_12.11.04_PM.jpg?v=1766423500'
    },

    // Devuelve el swatch HTML para un valor de color
    _getSwatchStyle: function (value) {
      var key = value.trim().toLowerCase();
      var lookup = this._colorPalette[key];
      if (!lookup) return null;
      if (lookup.startsWith('http')) {
        return 'background-image:url(' + lookup + ');background-size:cover;';
      }
      // Color sólido — si es muy claro, agregar borde
      return 'background-color:' + lookup + ';';
    },

    // Decide si una opción es de color
    _isColorOption: function (optionName) {
      var n = optionName.toLowerCase();
      return n === 'color' || n === 'colour' || n === 'color principal' || n === 'estampado';
    },

    _bindEvents: function () {
      var self = this;

      function tryInject() {
        var drawer = document.getElementById('CartDrawer');
        if (!drawer) return;
        if (!drawer.classList.contains('drawer--is-open')) return;
        if (drawer.querySelector('.crb-sidebar')) return;
        if (!drawer.querySelector('.cart__checkout')) return;
        self._injectPanel();
      }

      document.addEventListener('drawerOpen.CartDrawer', function () {
        self._waitForCartAndInject();
      });
      document.addEventListener('drawerOpen', function () {
        self._waitForCartAndInject();
      });
      document.addEventListener('ajaxProduct:added', function () {
        self._waitForCartAndInject();
      });
      document.addEventListener('cart:open', function () {
        self._waitForCartAndInject();
      });

      // Cada vez que Impulse reconstruye el carrito, forzar imágenes
      document.addEventListener('cart:updated', function () {
        setTimeout(function () { self._forceLoadImages(); }, 400);
      });

      var drawerObserver = new MutationObserver(function () {
        tryInject();
        // Forzar imágenes cada vez que el DOM del drawer cambia
        self._forceLoadImages();
      });

      var drawer = document.getElementById('CartDrawer');
      if (drawer) {
        drawerObserver.observe(drawer, { childList: true, subtree: true });
      } else {
        var bodyObserver = new MutationObserver(function () {
          var d = document.getElementById('CartDrawer');
          if (d) {
            bodyObserver.disconnect();
            drawerObserver.observe(d, { childList: true, subtree: true });
          }
        });
        bodyObserver.observe(document.body, { childList: true });
      }
    },

    // Fuerza la carga de todas las imágenes lazy del drawer y desactiva AOS
    _forceLoadImages: function () {
      var drawer = document.getElementById('CartDrawer');
      if (!drawer) return;

      // Quitar AOS de todas las imágenes del drawer para que sean siempre visibles
      drawer.querySelectorAll('[data-aos]').forEach(function (el) {
        el.removeAttribute('data-aos');
        el.classList.add('aos-animate');
        el.style.opacity = '';
        el.style.transform = '';
        el.style.transition = 'none';
      });
      drawer.querySelectorAll('.aos-init:not(.aos-animate)').forEach(function (el) {
        el.classList.add('aos-animate');
        el.style.opacity = '';
        el.style.transform = '';
      });

      // Forzar imágenes con data-src / data-srcset
      drawer.querySelectorAll('img').forEach(function (img) {
        if (img.dataset.src) img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.removeAttribute('loading');
        img.style.opacity = '';
      });
    },

    // Espera hasta 2s a que el carrito tenga HTML y esté abierto
    _waitForCartAndInject: function () {
      var self = this;
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        var drawer = document.getElementById('CartDrawer');
        if (drawer && drawer.classList.contains('drawer--is-open') && drawer.querySelector('.cart__checkout')) {
          clearInterval(interval);
          if (!drawer.querySelector('.crb-sidebar')) {
            self._injectPanel();
          }
        }
        if (attempts >= 20) clearInterval(interval); // máx 2s
      }, 100);
    },

    _injectPanel: function () {
      var drawer = document.getElementById('CartDrawer');
      if (!drawer) return;
      if (drawer.querySelector('.crb-sidebar')) return;
      var panel = document.createElement('div');
      panel.className = 'crb-sidebar';
      panel.innerHTML =
        '<div class="crb-sidebar__header"><p class="crb-sidebar__title">' + this.title + '</p></div>' +
        '<div class="crb-sidebar__body" id="crb-sidebar-body">' +
          (this._productsHtml || '<div class="crb-sidebar__loading"><span class="crb-sidebar__spinner"></span></div>') +
        '</div>';
      drawer.classList.add('drawer--with-sidebar');

      // En mobile: insertar justo antes del bloque de checkout (subtotal + botón)
      // En desktop: insertar al inicio del drawer (flex lo pone a la derecha)
      var isMobile = window.innerWidth <= 768;
      if (isMobile) {
        var form = drawer.querySelector('#CartDrawerForm');
        var drawerInner = form ? form.querySelector('.drawer__inner') : null;
        var drawerFooter = drawerInner ? drawerInner.querySelector('.drawer__footer') : null;
        if (drawerFooter) {
          drawerInner.insertBefore(panel, drawerFooter);
        } else if (drawerInner) {
          drawerInner.appendChild(panel);
        } else if (form) {
          form.appendChild(panel);
        } else {
          drawer.appendChild(panel);
        }
      } else {
        drawer.insertBefore(panel, drawer.firstChild);
      }

      if (this._productsHtml) {
        this._bindAddButtons(panel);
      } else {
        this._loadProducts(panel);
      }

      // Forzar carga de imágenes lazy en todo el drawer
      setTimeout(function () { CartSidebar._forceLoadImages(); }, 300);
    },

    _preloadProducts: function () {
      var self = this;
      fetch('/collections/' + this.collectionHandle + '/products.json?limit=' + this.maxProducts + '&sort_by=best-selling', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          self._productsData = data.products || [];
          self._productsHtml = self._buildProductsHtml(self._productsData);
        })
        .catch(function (e) { console.warn('[CartSidebar]', e); });
    },

    _loadProducts: function (panel) {
      var self = this;
      fetch('/collections/' + this.collectionHandle + '/products.json?limit=' + this.maxProducts + '&sort_by=best-selling', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          self._productsData = data.products || [];
          self._productsHtml = self._buildProductsHtml(self._productsData);
          var body = panel.querySelector('.crb-sidebar__body');
          if (body) { body.innerHTML = self._productsHtml; self._bindAddButtons(panel); }
        })
        .catch(function (e) { console.warn('[CartSidebar]', e); });
    },

    _buildProductsHtml: function (products) {
      if (!products.length) return '<p class="crb-sidebar__empty">Sin productos.</p>';
      var html = '';
      products.forEach(function (p) {
        var v = p.variants && p.variants[0];
        if (!v) return;
        var img = p.images && p.images[0] ? p.images[0].src.replace(/(\.[^.]+)$/, '_300x$1') : '';
        var price = CartSidebar._fmt(parseFloat(v.price) * 100);
        var compareVal = parseFloat(v.compare_at_price);
        var priceVal = parseFloat(v.price);
        var compare = v.compare_at_price && compareVal > priceVal
          ? '<s class="crb-sidebar__compare">' + CartSidebar._fmt(compareVal * 100) + '</s>' : '';
        var savings = v.compare_at_price && compareVal > priceVal
          ? '<span class="crb-sidebar__save">Ahorras ' + CartSidebar._fmt((compareVal - priceVal) * 100) + '</span>' : '';
        html +=
          '<div class="crb-sidebar__item">' +
            '<a href="/products/' + p.handle + '" class="crb-sidebar__link">' +
              (img ? '<img class="crb-sidebar__img" src="' + img + '" alt="' + p.title + '" loading="lazy">' : '<div class="crb-sidebar__img crb-sidebar__img--empty"></div>') +
              '<div class="crb-sidebar__info">' +
                '<p class="crb-sidebar__name">' + p.title + '</p>' +
                '<div class="crb-sidebar__prices">' + compare + '<strong>' + price + '</strong>' + savings + '</div>' +
              '</div>' +
            '</a>' +
            '<button class="crb-sidebar__btn" data-handle="' + p.handle + '">Añadir al carrito</button>' +
          '</div>';
      });
      return html;
    },

    _bindAddButtons: function (panel) {
      panel.querySelectorAll('.crb-sidebar__btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          CartSidebar._openPopup(btn.dataset.handle);
        });
      });
    },

    _fmt: function (cents) {
      var fmt = window.theme && window.theme.settings && window.theme.settings.moneyFormat;
      var amount = Math.round(cents / 100).toLocaleString('es-PE');
      return fmt ? fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount) : 'S/. ' + amount;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { CartSidebar.init(); });
  } else {
    CartSidebar.init();
  }
})();